var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPost = function SvgIconPost(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 52.9,
    width: 8.2,
    height: 9.11,
    style: {
      fill: "#d0895a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 52.9,
    width: 3.2,
    height: 9.11,
    style: {
      fill: "#b56a4b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 52.4,
    width: 8.2,
    height: 2.96,
    style: {
      fill: "#b56a4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9,13.4h-30A12.6,12.6,0,0,0,1.3,26V51.6H26.5V31.5H43.9Z",
    style: {
      fill: "#414446"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4,51.6H6.1V26a12.7,12.7,0,0,1,25.3,0V48.4",
    style: {
      fill: "#272523"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.1,
    y: 25.3,
    width: 28.8,
    height: 17.09,
    style: {
      fill: "#eaeaea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1,25.3l13.3,9.1a2,2,0,0,0,2.1,0l13.4-9.1L18.6,35.7a2,2,0,0,1-2.3,0Z",
    style: {
      fill: "#d1cfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,33.7a7.6,7.6,0,0,1-1.6.6l12.8,8.1Z",
    style: {
      fill: "#d1cfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7,33.8l-.4-.2L3.1,42.4l12.6-8C15.4,34.3,14.9,33.8,14.7,33.8Z",
    style: {
      fill: "#d1cfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.1 25.3 17.5 35.5 31.9 25.3 3.1 25.3",
    style: {
      fill: "#f4f2ef"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 25.3,
    width: 23.9,
    height: 17.09,
    style: {
      fill: "#d1cfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8,25.5A13.9,13.9,0,0,0,13.9,11.6H48.1A13.9,13.9,0,0,1,62,25.5V51.4H27.8Z",
    style: {
      fill: "#277098"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9,24.4A13.8,13.8,0,0,0,48.1,11.6H13.9A13.9,13.9,0,0,1,27.8,24.4Z",
    style: {
      fill: "#2e80a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8,25.5A13.9,13.9,0,0,0,0,25.5V50.3H1.3V26a12.6,12.6,0,0,1,25.2,0V50.3h1.3Z",
    style: {
      fill: "#4894b5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 50.3,
    width: 25.2,
    height: 1.31,
    style: {
      fill: "#4894b5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 50.3,
    width: 62,
    height: 2.63,
    style: {
      fill: "#d0895a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 48.1,
    width: 27.8,
    height: 2.19,
    style: {
      fill: "#277098"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.4,
    y: 20,
    width: 23.6,
    height: 1.52,
    rx: 0.8,
    style: {
      fill: "#eaeaea"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.2,
    y: 20,
    width: 4.2,
    height: 1.52,
    rx: 0.8,
    style: {
      fill: "#eaeaea"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    width: 9.8,
    height: 6.63,
    style: {
      fill: "#ea565e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 4.6,
    width: 2,
    height: 32.87,
    style: {
      fill: "#ea565e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.3,
    cy: 37.5,
    r: 2.3,
    style: {
      fill: "#ea565e"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPost, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-post.1ad8598b.svg";
export { ForwardRef as ReactComponent };